import { render } from "./EditEmployees.vue?vue&type=template&id=5f60258c"
import script from "./EditEmployees.vue?vue&type=script&lang=js"
export * from "./EditEmployees.vue?vue&type=script&lang=js"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__